<div class="sortable-holder">
    <!-- [sortablejs]="sections" [sortablejsOptions]="sortConfig"-->
    <div class="list-section item-draggable animate-scale-in-out-delayed" *ngFor="let s of sections; let i=index;">
        <rl-indentation-buttons *ngIf="collapsedAll" [level]="s.indentation" [maxLevel]="3" (levelChange)="updateIndentation(i, $event)"></rl-indentation-buttons>
        <rl-drag-handle class="item-drag-handler" [order]="s.order" [maxOrder]="sections.length - 1" (orderChange)="updateOrder(i, $event)" ></rl-drag-handle><!--*ngIf="collapsedAll && sections.length > 1" // isOpen:{{isOpen}} -->
        <rl-section [section]="s" [isOpen]="true" (isOpenChange)="updateCollapsedAll($event)" (onDelete)="removeSectionFromList(i)">
            <rl-assignments-list [assignments]="s.assignments"></rl-assignments-list>
        </rl-section>
    </div>
</div>